var map = {
	"./agro.svg": 963,
	"./bank.svg": 328,
	"./basket.svg": 964,
	"./building.svg": 614,
	"./ceo.svg": 785,
	"./chemistry.svg": 84,
	"./horlogy.svg": 390,
	"./industry.svg": 424,
	"./invest.svg": 389,
	"./luxury.svg": 505,
	"./misc.svg": 938,
	"./podium.svg": 746,
	"./services.svg": 366,
	"./shipping.svg": 452,
	"./stadium.svg": 91,
	"./technology.svg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;